import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAxiosClient from "../../../hooks/useAxiosClient";
import { TRootState } from "../../../store";
import {
  setAddParameterPanelStatus,
  setOpenIndex,
  setRefreshParametrsEntity,
  udpateAddParameterData,
} from "../../../reducers/riskEngineSlice";
import { toast } from "react-toastify";
import { validateAddEditParameterFun } from "./vliadtion-scores";

const useAddParameter = () => {
  const { handlePostCall, handlePutCall, handleDeleteCall } = useAxiosClient();
  const dispatch = useDispatch();

  const {
    adminId,
    addParameterPanelStatus,
    getAllParametesRules,
    addParameterRuleData,
    addEditParameterMode,
    selectedParameter,
    activeCategoryTab,
    deletedParametrId,
    addRuleForSelectedParam,
    addRulePanelStatus,
    openIndex,
    ruleMode,
  } = useSelector((state: TRootState) => ({
    adminId: state.auth.adminId,
    addParameterPanelStatus:
      state.riskEngineDetailsSlice.addParameterPanelStatus,
    addRulePanelStatus: state.riskEngineDetailsSlice.addRulePanelStatus,
    getAllParametesRules: state.riskEngineDetailsSlice.getAllParametesRules,
    activeCategoryTab: state.riskEngineDetailsSlice.activeCategoryTab,
    addParameterRuleData: state.riskEngineDetailsSlice.addParameterRuleData,
    addEditParameterMode: state.riskEngineDetailsSlice.addEditParameterMode,
    selectedParameter: state.riskEngineDetailsSlice.selectedParameter,
    deletedParametrId: state.riskEngineDetailsSlice.deletedParametrId,
    addRuleForSelectedParam:
      state.riskEngineDetailsSlice.addRuleForSelectedParam,
    openIndex: state.riskEngineDetailsSlice.openIndex,
    ruleMode: state.riskEngineDetailsSlice.ruleMode,
  }));
  const [rebalanceRequired, setRebalanceRequired] = useState(false);
  const [deleteParameterModal, setDeleteParameterModel] = useState(false);
  const [searchText, setSearchtext] = useState("");
  const [adjustTargetParams, setAdjustTargetParams] = useState<any[]>([]);
  const onUpdateAddParameterInput = (type: string, value: any) => {
    let addParamData = addParameterRuleData;
    if (type === "PARAMETERNAME") {
      addParamData = {
        ...addParamData,
        param_name: value,
      };
    } else if (type === "PARAMETERTYPE") {
      addParamData = {
        ...addParamData,
        type: value,
      };
    } else if (type === "DESCRIPTION") {
      addParamData = {
        ...addParamData,
        desc: value,
      };
    } else if (type === "WEIGHT") {
      addParamData = {
        ...addParamData,
        weight: value,
      };
    }
    dispatch(
      udpateAddParameterData({
        addParameterRuleData: addParamData,
      })
    );
  };

  useEffect(() => {
    if (addRulePanelStatus && selectedParameter) {
      if (
        selectedParameter.param_id === addParameterRuleData.param_id &&
        ruleMode == "add"
      ) {
        const updatedRules = [
          ...selectedParameter.rules,
          ...(addParameterRuleData.rules || []),
        ];
        // dispatch(
        //   udpateAddParameterData({
        //     addParameterRuleData: selectedParameter,
        //   })
        // );

        dispatch(
          udpateAddParameterData({
            addParameterRuleData: {
              ...selectedParameter,
              rules: updatedRules,
            },
          })
        );
      }
    }
  }, [addRulePanelStatus]);

  useEffect(() => {
    if (
      ((addEditParameterMode === "EDIT" || addEditParameterMode === "DELETE") &&
        selectedParameter) ||
      (addRulePanelStatus && selectedParameter && ruleMode != "add")
    ) {
      dispatch(
        udpateAddParameterData({
          addParameterRuleData: selectedParameter,
        })
      );
    }
  }, [addEditParameterMode]);

  useEffect(() => {
    if (
      activeCategoryTab &&
      addEditParameterMode === "ADD" &&
      !addRulePanelStatus
    ) {
      dispatch(
        udpateAddParameterData({
          addParameterRuleData: {
            ...addParameterRuleData,
            type: activeCategoryTab,
          },
        })
      );
    }
  }, [activeCategoryTab]);
  const onSaveParameterData = () => {
    // if (validateAddEditParameter()) {
    const isValid = validateAddEditParameterFun({
      addParameterRuleData,
      getAllParametesRules,
      setRebalanceRequired,
      adjustTargetParams,
      isDelete: false,
    });

    if (!isValid) return;

    const obj = {
      source: {
        param_id: 0,
        param_name: addParameterRuleData?.param_name,
        type: addParameterRuleData?.type,

        desc: addParameterRuleData?.desc,
        status: 1,
        weight: addParameterRuleData?.weight
          ? Number(addParameterRuleData?.weight)
          : 0,
        sub_type: "",
        rules: addParameterRuleData.rules.map((rule: any) => ({
          rule_id: 0,
          rule_name: rule.rule || rule.rule_name,
          score: rule.score,
          status: rule.status,
        })),
      },
      target:
        adjustTargetParams.length > 0
          ? adjustTargetParams?.map((param) => ({
              param_id: param.param_id,
              param_name: param.param_name,
              weight: param.weight,
              type: param.param_type || param.type,
              sub_type: param.subtype || param.sub_type,
              desc: param.desc,
              rules: param.rules.map((rule: any) => ({
                rule_id: rule.rule_id,
                rule_name: rule.rule || rule.rule_name,
                score: rule.score,
                status: rule.status,
              })),
            }))
          : [],
    };

    handlePostCall({
      URL: `solutions/risk-engine/adminId/${adminId}/params`,
      apiParams: obj,
    })
      .then(({ data, status }) => {
        toast.success(status.description);
        dispatch(setAddParameterPanelStatus(false));
        dispatch(setRefreshParametrsEntity());
      })
      .catch((err: any) => {});
    // }
  };

  const validateAddEditParameter = () => {
    if (!addParameterRuleData.param_name) {
      toast.error("Please enter Parameter name");
      return false;
    }

    if (!addParameterRuleData.weight) {
      toast.error("Please enter weight");
      return false;
    }

    if (!addParameterRuleData.type) {
      toast.error("Please select Category");
      return false;
    }

    const rules = addParameterRuleData.rules || [];

    if (rules.length > 0) {
      for (let i = 0; i < rules.length; i++) {
        const rule = rules[i];

        if (!rule.rule_name || rule.rule_name.trim() === "") {
          toast.error(`Condition is required for Rule ${i + 1}`);
          return false;
        }

        // if (!rule.score) {
        //   toast.error(`Score is required for Rule ${i + 1}`);
        //   return false;
        // }
      }
    }
    const existingWeightTotal = getAllParametesRules.reduce(
      (sum, param) => sum + Number(param.weight || 0),
      0
    );
    const totalWeight =
      existingWeightTotal + Number(addParameterRuleData.weight);
    if (totalWeight > 100) {
      setRebalanceRequired(true);
      toast.error("Total parameter weight in this category cannot exceed 100");
      return false;
    }
    const weight = Number(addParameterRuleData.weight);
    const scores = (addParameterRuleData.rules || [])
      .filter((rule) => rule.status !== 0)
      .map((rule) => Number(rule.score || 0));

    const exceedWeight = scores.some((score) => score > weight);
    const hasWeightScore = scores.includes(weight);

    const allSameScores = scores.every((score) => score === scores[0]);

    if (addParameterRuleData?.rules?.length > 0) {
      if (exceedWeight) {
        toast.error(
          `Rule score should not exceed parameter weight (${weight})`
        );
        return false;
      }

      if (!hasWeightScore) {
        toast.error(
          `One rule score must be equal to the parameter weight (${weight})`
        );
        return false;
      }

      if (allSameScores && scores.length > 1) {
        toast.error("All rule scores should not be the same");
        return false;
      }
    }

    return true;
  };
  const handleRuleChange = (
    index: number,
    field: string,
    value: string | number
  ) => {
    const updatedRules = [...addParameterRuleData.rules];
    if (!updatedRules[index]) return;

    updatedRules[index] = {
      ...updatedRules[index],
      [field]: value,
    };

    dispatch(
      udpateAddParameterData({
        addParameterRuleData: {
          ...addParameterRuleData,
          rules: updatedRules,
        },
      })
    );
  };

  const handleAddRule = () => {
    const newRule = {
      temp_id: Date.now(),
      rule_id: 0,
      rule_name: "",
      score: 0,
      status: 1,
    };

    const updatedRules = [...(addParameterRuleData.rules || []), newRule];

    dispatch(
      udpateAddParameterData({
        addParameterRuleData: {
          ...addParameterRuleData,
          rules: updatedRules,
        },
      })
    );

    dispatch(setOpenIndex([...openIndex, newRule.temp_id]));
  };

  const handleDeleteRule = (ruleKey: number) => {
    const rules = addParameterRuleData.rules || [];

    const updatedRules = rules
      .map((rule: any) => {
        if (rule.rule_id !== ruleKey && rule.temp_id !== ruleKey) return rule;

        if (rule.rule_id) return { ...rule, status: 0 };

        return null;
      })
      .filter(Boolean);

    dispatch(
      udpateAddParameterData({
        addParameterRuleData: {
          ...addParameterRuleData,
          rules: updatedRules,
        },
      })
    );

    const updatedOpenIndex = openIndex.filter((id) => id !== ruleKey);
    dispatch(setOpenIndex(updatedOpenIndex));
  };

  const onUpdateParameterData = () => {
    // const images = [];
    // if (validateAddEditParameter()) {
    const isValid = validateAddEditParameterFun({
      addParameterRuleData,
      getAllParametesRules,
      setRebalanceRequired,
      adjustTargetParams,
      isDelete: false,
    });

    if (!isValid) return;
    const obj = {
      source: {
        param_id: selectedParameter?.param_id,
        param_name: addParameterRuleData?.param_name,
        type: addParameterRuleData?.type,

        desc: addParameterRuleData?.desc,
        status: 2,
        weight: addParameterRuleData?.weight
          ? Number(addParameterRuleData?.weight)
          : 0,
        sub_type: "",
        rules: addParameterRuleData.rules.map((rule: any) => ({
          rule_id: rule.rule_id,
          rule_name: rule.rule || rule.rule_name,
          score: rule.score,
          status: rule.status,
        })),
      },
      target:
        adjustTargetParams.length > 0
          ? adjustTargetParams?.map((param) => ({
              param_id: param.param_id,
              param_name: param.param_name,
              weight: param.weight,
              type: param.param_type || param.type,
              sub_type: param.subtype || param.sub_type,
              desc: param.desc,
              status: param.status,
              rules: param.rules.map((rule: any) => ({
                rule_id: rule.rule_id,
                rule_name: rule.rule || rule.rule_name,
                score: rule.score,
                status: rule.status,
              })),
            }))
          : [],
    };
    handlePutCall({
      URL: `solutions/risk-engine/adminId/${adminId}/params/rules`,
      apiParams: obj,
    })
      .then(({ data, status }) => {
        toast.success(status.description);
        dispatch(setAddParameterPanelStatus(false));
        dispatch(setRefreshParametrsEntity());
      })
      .catch((err: any) => {});
    // }
  };
  const deleteParameterValidationheck = () => {
    const isValid = validateAddEditParameterFun({
      addParameterRuleData,
      getAllParametesRules,
      setRebalanceRequired,
      adjustTargetParams,
      isDelete: true,
    });

    if (!isValid) return;
    setDeleteParameterModel(true);
  };
  const deleteParameterFun = () => {
    const obj = {
      source: {
        param_id: selectedParameter?.param_id,
        param_name: addParameterRuleData?.param_name,
        type: addParameterRuleData?.type,

        desc: addParameterRuleData?.desc,
        status: 0,
        weight: addParameterRuleData?.weight
          ? Number(addParameterRuleData?.weight)
          : 0,
        sub_type: "",
        rules: addParameterRuleData.rules.map((rule: any) => ({
          rule_id: rule.rule_id,
          rule_name: rule.rule || rule.rule_name,
          score: rule.score,
          status: rule.status,
        })),
      },
      target:
        adjustTargetParams.length > 0
          ? adjustTargetParams?.map((param) => ({
              param_id: param.param_id,
              param_name: param.param_name,
              weight: param.weight,
              type: param.param_type || param.type,
              sub_type: param.subtype || param.sub_type,
              desc: param.desc,
              status: param.status,
              rules: param.rules.map((rule: any) => ({
                rule_id: rule.rule_id,
                rule_name: rule.rule || rule.rule_name,
                score: rule.score,
                status: rule.status,
              })),
            }))
          : [],
    };
    handlePutCall({
      URL: `solutions/risk-engine/adminId/${adminId}/params/rules`,
      apiParams: obj,
    })
      .then(({ data, status }) => {
        toast.success(status.description);
        dispatch(setAddParameterPanelStatus(false));
        dispatch(setRefreshParametrsEntity());
      })
      .catch((err: any) => {});
  };

  return {
    addParameterPanelStatus,
    setSearchtext,
    searchText,
    onUpdateAddParameterInput,
    onSaveParameterData,
    addParameterRuleData,
    handleRuleChange,
    handleAddRule,
    handleDeleteRule,
    addEditParameterMode,
    rebalanceRequired,
    setRebalanceRequired,
    getAllParametesRules,
    adjustTargetParams,
    setAdjustTargetParams,
    onUpdateParameterData,
    deletedParametrId,
    addRuleForSelectedParam,
    selectedParameter,
    deleteParameterValidationheck,
    deleteParameterModal,
    setDeleteParameterModel,
    deleteParameterFun,
  };
};
export default useAddParameter;
